import { useEffect, useState } from 'react'
import { isAppHydrated } from 'utils/appHydration'
import { getCookies } from 'utils/cookieHelpers'

/**
 * Whether a cookie-based condition holds, for render: false during the page's first hydration (the server HTML
 * of a server-rendered page has no cookie), then read on every render, as before (so a cookie set later by the
 * page is picked up on its next render). Mounted after the first hydration (client navigation, pages behind the
 * client-only PersistGate), it reads right away.
 */
export const useAfterHydration = (read: () => boolean): boolean => {
  const [mounted, setMounted] = useState(() => typeof window !== 'undefined' && isAppHydrated())
  useEffect(() => setMounted(true), [])
  return mounted && read()
}

/** Whether a brand cookie (isIshaAddress, isMedleveAddress, isWeightAddress…) is set (see useAfterHydration). */
export const useBrandCookie = (name: string): boolean => useAfterHydration(() => Boolean(getCookies(name)?.isValid))
